import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55046fec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recipe" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "recipe-header" }
const _hoisted_5 = { class: "title-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "share-block",
  "data-html2canvas-ignore": "true"
}
const _hoisted_8 = {
  key: 0,
  viewBox: "0 0 64 64",
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  "enable-background": "new 0 0 64 64"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M-264.2-339.9c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9c0 4.3-3.5 7.9-7.9 7.9zm0-12.9c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9c0-2.6-2.2-4.9-4.9-4.9zM-232.1-356c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9-3.6 7.9-7.9 7.9zm0-12.8c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9zM-232.1-323.9c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9-3.6 7.9-7.9 7.9zm0-12.8c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9z",
  transform: "translate(280 380)",
  fill: "#ffffff",
  class: "fill-134563"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "m-238.6-333.2-20.6-10.3 1.4-2.9 20.7 10.3-1.5 2.9M-257.8-349.3l-1.4-2.8 20.6-10.3 1.5 2.8-20.7 10.3",
  transform: "translate(280 380)",
  fill: "#ffffff",
  class: "fill-134563"
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "close-button",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<title data-v-55046fec></title><g data-name=\"Layer 2\" id=\"Layer_2\" fill=\"#ffffff\" data-v-55046fec><path d=\"M4,29a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l24-24a1,1,0,1,1,1.42,1.42l-24,24A1,1,0,0,1,4,29Z\" data-v-55046fec></path><path d=\"M28,29a1,1,0,0,1-.71-.29l-24-24A1,1,0,0,1,4.71,3.29l24,24a1,1,0,0,1,0,1.42A1,1,0,0,1,28,29Z\" data-v-55046fec></path></g><g id=\"frame\" data-v-55046fec><rect fill=\"none\" height=\"32\" width=\"32\" data-v-55046fec></rect></g>", 3)
const _hoisted_16 = [
  _hoisted_13
]
const _hoisted_17 = {
  key: 0,
  class: "share-popup"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "1" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M255.13 385.54a15 15 0 0 1-11.14-5L103.67 224.93a15 15 0 0 1 11.14-25H171V63a15 15 0 0 1 15-15h138.3a15 15 0 0 1 15 15v136.89h56.16a15 15 0 0 1 11.14 25L266.27 380.58a15 15 0 0 1-11.14 4.96Zm-106.6-155.65 106.6 118.25 106.61-118.25H324.3a15 15 0 0 1-15-15V78H201v136.89a15 15 0 0 1-15 15Z",
      fill: "#ffffff",
      class: "fill-000000"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M390.84 450H119.43a65.37 65.37 0 0 1-65.3-65.29v-38.17a15 15 0 0 1 30 0v38.17a35.34 35.34 0 0 0 35.3 35.29h271.41a35.33 35.33 0 0 0 35.29-35.29v-38.17a15 15 0 0 1 30 0v38.17A65.37 65.37 0 0 1 390.84 450Z",
      fill: "#ffffff",
      class: "fill-000000"
    })
  ])
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "PDF", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.249 17.25h-3a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-3M3.749 9.75h1.5",
    fill: "none",
    stroke: "#ffffff",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5px",
    class: "stroke-000000"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.249 12.75h13.5v10.5h-13.5zM18.749 6.75h-13.5v-4.5a1.5 1.5 0 0 1 1.5-1.5h10.5a1.5 1.5 0 0 1 1.5 1.5ZM8.249 15.75h7.5M8.249 18.75h5.25",
    fill: "none",
    stroke: "#ffffff",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5px",
    class: "stroke-000000"
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Drucken", -1))
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "mail email e-mail letter" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M28 13a1 1 0 0 0-1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8a1 1 0 0 0-2 0v8a3 3 0 0 0 .88 2.12A3 3 0 0 0 6 25h20a3 3 0 0 0 2.12-.88A3 3 0 0 0 29 22v-8a1 1 0 0 0-1-1Z",
      fill: "#ffffff",
      class: "fill-000000"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M15.4 18.8a1 1 0 0 0 1.2 0l11.81-8.86a1 1 0 0 0 .3-1.23 3.06 3.06 0 0 0-.59-.83A3 3 0 0 0 26 7H6a3 3 0 0 0-2.12.88 3.06 3.06 0 0 0-.59.83 1 1 0 0 0 .3 1.23ZM6 9h20a.9.9 0 0 1 .28 0L16 16.75 5.72 9A.9.9 0 0 1 6 9Z",
      fill: "#ffffff",
      class: "fill-000000"
    })
  ])
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mail", -1))
const _hoisted_28 = { class: "description" }
const _hoisted_29 = { class: "ingredients" }
const _hoisted_30 = { class: "prep" }

import { useRoute } from 'vue-router'
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import html2pdf from 'html2pdf.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipeView',
  setup(__props) {

const store = useStore()

const route = useRoute()
const slug = route.params.slug

const recipe = computed(() => store.getters.getRecipeContent(slug))

let shareOptions = ref(false)

const input = ref<HTMLInputElement | null>(null)

onMounted(() => {
  input.value?.focus()
})

function toggleShareOptions() {
    shareOptions.value = !shareOptions.value
}

function formatTime(time: number) {

    if (time < 60) {
        return time + ' Minuten';
    }

    else {
        const hours = Math.floor(time / 60);
        const minutes = time % 60;
        let minuteString = '';

        if (minutes == 0) {
            minuteString = ''
        } else {
            minuteString = minutes + ' Minuten';
        } 

        if (hours < 2) {
            return hours + ' Stunde ' + minuteString;
        } else return hours + ' Stunden ' + minuteString;
    }

}

function mailRecipe() {
    const subject = 'Rezept-Link - ' + recipe.value.title;
    const body = 'Hier findest du den Link zum Rezept: ' + window.location.origin + route.fullPath;

    return 'mailto:%20?body=' + encodeURIComponent(body) + '&subject=' + encodeURIComponent(subject)
}

function downloadPDF() {

    const element = input.value;
    const options = { 
        margin: 20, 
        filename: recipe.value.title + ' - Rezept.pdf', 
        image: {type: 'jpg', quality: 0.95}, 
        html2canvas: {dpi: 192, letterRendering: true}, 
        jsPDF: {format: 'a4', orientation: 'portrait'} 
    };
    html2pdf(element, options).set({
        pagebreak: { mode: 'avoid-all' }
    });

}

function printRecipe() {
    window.print()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(recipe).img,
        alt: _unref(recipe).title
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", {
      class: "right",
      ref_key: "input",
      ref: input
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", null, _toDisplayString(_unref(recipe).title), 1),
          _createElementVNode("h4", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recipe).tags, (tag) => {
              return (_openBlock(), _createElementBlock("span", { key: tag }, _toDisplayString(tag) + " | ", 1))
            }), 128)),
            _createTextVNode(" Zubereitungszeit: " + _toDisplayString(formatTime(_unref(recipe).timeActive)), 1),
            (_unref(recipe).timePassive != 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " | " + _toDisplayString(_unref(recipe).timePassiveMode) + ": " + _toDisplayString(formatTime(_unref(recipe).timePassive)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "share-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleShareOptions()))
          }, [
            (!_unref(shareOptions))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_11))
              : _createCommentVNode("", true),
            (_unref(shareOptions))
              ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_16))
              : _createCommentVNode("", true)
          ]),
          (_unref(shareOptions))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "share-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadPDF()))
                  }, _hoisted_19),
                  _hoisted_20
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "share-button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (printRecipe()))
                  }, _hoisted_22),
                  _hoisted_23
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    class: "share-link",
                    href: mailRecipe()
                  }, [
                    _createElementVNode("button", {
                      class: "share-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (downloadPDF()))
                    }, _hoisted_26)
                  ], 8, _hoisted_24),
                  _hoisted_27
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("p", null, _toDisplayString(_unref(recipe).desc), 1)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("h3", null, _toDisplayString(_unref(recipe).content.ingredientsHeading), 1),
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recipe).content.ingredientsList, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.ingredient
            }, [
              _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
              _createElementVNode("td", null, _toDisplayString(item.ingredient), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("h3", null, _toDisplayString(_unref(recipe).content.prepHeading), 1),
        _createElementVNode("ol", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recipe).content.prepList, (item) => {
            return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ], 512)
  ]))
}
}

})